module.exports = __webpack_public_path__ + "static/ourwork-corporate-events-3da96c5bbfe7e348da320b03b31fcf0a.jpg";